import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { User } from '../user/model/User.model';
import { JwtHelperService } from '@auth0/angular-jwt';
import { EnvironmentService } from '../environment/environment.service';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { ErrorService } from '../error/error.service';
import { AbstractServiceWithoutToken } from '@app/shared/service/base/abstractServiceWithoutToken';
import { LoginResponse } from './loginResponse.model';
import { EntityInterface } from '@app/shared/model/entity/interfaces/entityInterface.model';
import { ResetPassword } from '../password/resetPassword.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends AbstractServiceWithoutToken {


  public baseBackUrl: string;

  constructor(
    private httpClient: HttpClient,
    private jwtService: JwtHelperService,
    public environmentService: EnvironmentService,
    public errorService: ErrorService,
    public router: Router
  ) {
    super(
      environmentService,
      router,
      errorService
    );
  }

  public static getToken(): string {
    const userString = localStorage.getItem('userAddress');
    return userString;
  }

  login(usernameOrEmail: string, password: string, externalAcces: boolean): Observable<LoginResponse> {
    const urlApi = this.baseBackUrl + 'api/auth/signin';
    return this.httpClient.post<LoginResponse>(urlApi, {usernameOrEmail,  password , externalAcces }, {})
      // añadimos el manejo de errores
      .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, false) ));
    }

  logout(): void {
    const user = this.getUser();
    if (user) {
      this.removeToken();
      this.removeUser();
      // const urlApi = this.baseBackUrl + 'api/auth/logout';
      // this.httpClient.get(urlApi)
      //   // añadimos el manejo de errores
      //   .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, false) ))
      //   .subscribe();
      void this.router.navigate(['login']);
    }
  }

  public resetPassword(resetPassword: ResetPassword): Observable<EntityInterface> {
    const userName = resetPassword.username;
    const urlApi = `${this.baseBackUrl}api/auth/resetPassword/${userName}`;
  
    const observable: Observable<EntityInterface> = this.httpClient.patch<EntityInterface>(urlApi, resetPassword, {withCredentials: false})
    // añadimos el manejo de errores
    .pipe(catchError((error: HttpErrorResponse) => this.handleError(error, true, `common.auth.forgotPassword.error`) ));
    return observable;
  }

  setUser(user: User): void {
    const userString = JSON.stringify(user);
    localStorage.setItem('cronossUser', userString);
  }

  setToken(token: string): void {
    localStorage.setItem('userAddress', token);
  }

  getUser(): User {
      const userString = localStorage.getItem('cronossUser');
      if (userString) {
        const user: User = JSON.parse(userString);
        return user;
      } else {
        return null;
      }
  }


  isAuthenticate(): boolean {
    if (environment.security) {
      const user: User = this.getUser();
      if (user) {
        const token = AuthService.getToken();
        // Check whether the token is expired and return
        // true or false
        return !this.jwtService.isTokenExpired(token);
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  removeToken(): void {
    localStorage.removeItem('userAddress');
  }

  removeUser(): void {
    localStorage.removeItem('cronossUser');
  }

  havePermission(permissionCode: string, level?: string): boolean {
    if (level === undefined || level === null) {
      level = 'R';
    }
    if (environment.security) {
      if (this.isAuthenticate()) {
        const user = this.getUser();
        if (user) {
          const role = user.role;
          if (role) {
            const permissions = role.permissions;
            if (permissions) {
              const permission = permissions.find(permissionItem => permissionItem.permission.code === permissionCode);
              if (permission) {
                if (level === 'R') {
                  return true;
                }
                if (level) {
                  if (level === permission.level) {
                    return true;
                  }
                } else {
                  return true;
                }
              }
            }
          }
        }
      } else {

        // const token = AuthService.getToken();
        // Check whether the token is expired and return
        // true or false
        // console.log('El token caduca en: ', this.jwtService.getTokenExpirationDate(token));
      }
      return false;
    } else {
      return true;
    }
  }

}
